import { CURRENCY } from 'src/types';

export enum VOUCHER_TYPE_USAGE {
    SINGLE = 'single',
    BALANCE = 'balance',
}

export type VoucherType = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    code: string;
    valid_from: string;
    is_active: boolean;
    usage: VOUCHER_TYPE_USAGE;
    description: string | null;
    valid_duration: string | null;
    valid_to: string | null;
    max_count: number | null;
    amount: number | null;
    percent: string | null;
    currency: CURRENCY;
};
